import{jsxs as r,jsx as e}from"react/jsx-runtime";import{forwardRef as a,useState as t,useRef as n,useEffect as o,useImperativeHandle as l,isValidElement as s,cloneElement as i}from"react";import d from"tailwind-styled-components";import m from"clsx";import{X as p}from"lucide-react";import{twString as u,isButton as c}from"../utils.js";import b from"../loader/loader.js";const f=d.div`
  inline-flex
  items-center
  min-w-0
  relative
  rounded
  transition-all
  w-full

  md:w-auto
`,h=u`
  bg-white
  border-t
  border-transparent
  shadow
  hover:border-t-gray-50
  hover:-translate-y-px
  hover:shadow-brand-primary/20
  hover:shadow-lg

  dark:bg-gray-700
  dark:hover:border-t-transparent
  dark:hover:shadow-black/40
`,g=u`
  -translate-y-px
  border-t-gray-50
  shadow-brand-primary/20
  shadow-lg

  dark:border-t-transparent
  dark:shadow-black/40
`,x=u`
  bg-white/75
  hover:border-t-transparent
  hover:-translate-y-0
  hover:shadow
`,_=u`
  bg-white
  shadow-[inset_0_0_0_1px_rgba(0,0,0,0.1),inset_0_1px_2px_rgba(0,0,0,0.05)]

  dark:bg-white/10
`,w=u`
  shadow-[inset_0_0_0_1px_rgba(0,0,0,0.1),inset_0_1px_2px_rgba(0,0,0,0.05),0_0_0_2px_rgb(75_77_241_/_0.5)]
`,y=u`
  bg-black/5
  shadow-[inset_0_0_0_1px_rgba(0,0,0,0.1)]
`,v=u`
  bg-transparent
  shadow-none
`,k=d.span`
  //absolute
  inline-flex
  items-center
  pl-3
  cursor-text
  text-gray-500
`,N=d(k)`
  left-auto
  pr-3
  transition-transform
`,C=d.input`
  bg-transparent
  flex-grow
  min-w-0
  outline-none
`,z=d.button`
  [font-size:.5em]
  bg-gray-400
  flex-shrink-0
  h-4
  inline-flex
  items-center
  justify-center
  leading-none
  p-[2px]
  rounded-full
  text-white
  transition-opacity
  w-4

  dark:bg-gray-800
`,j=d(b)`
  mr-3
  transition-transform
`,B=a((({allowClear:a=!1,className:d,clearButtonClassName:u,defaultValue:b,inputClassName:B,isLoading:F,onClear:D,prefix:I=null,size:L="normal",suffix:P=null,variant:V="card",onChange:q,...A},E)=>{const[G,H]=t(!1),[J,K]=t(""),M=n(null),O={small:14,normal:18,large:22,xlarge:28},Q=m(d,{[g]:G&&"card"===V,"rounded-l-[3rem]":c(I),"rounded-r-[3rem]":c(P),"text-base":"normal"===L,"text-sm":"small"===L,[h]:"card"===V,[_]:"flat"===V,[v]:"ghost"===V,[y]:A.disabled&&"flat"===V,[x]:A.disabled&&"card"===V,[w]:G&&"flat"===V}),R=m(B,{"p-2":"small"===L,"px-3":"normal"===L,"py-2":"normal"===L}),S=m({"!pl-4":c(I),"!pr-4":c(P),"!py-[.555rem]":!0,"!text-sm":"normal"===L,"border-l-black/5":c(P),"border-l":c(P),"border-r-black/5":c(I),"border-r":c(I),"hover:shadow-none":!0,"hover:translate-y-0":!0,"left-0":c(I),"right-0":c(P),"rounded-l-none":c(P),"rounded-r-none":c(I),"shadow-none":!0,"translate-y-0":!0,"flex-shrink-0":!0}),T=m({"-translate-x-6":a&&!!J&&!F||F&&!J,"-translate-x-12":a&&!!J&&F}),U=m(u,{"opacity-0":!J,"pointer-events-none":!J,absolute:!c(P),"right-3":!c(P),"mr-3":c(P)}),W=m({"-translate-x-6":a&&!!J&&!c(P),"translate-x-6":c(P)&&a&&!J}),X={size:"small",className:S},Y=r=>{r.stopPropagation(),M.current&&M.current.focus()};return o((()=>{"function"==typeof q&&q({target:{value:A.value||b||""}}),K(A.value||b||"")}),[A.value,b]),l(E,(()=>M.current)),r(f,{className:Q,children:[I&&!c(I)&&e(k,{onClick:Y,children:s(I)?i(I,{size:O[L]}):I}),c(I)&&s(I)&&i(I,X),e(C,{...A,className:R,onBlur:r=>{"function"==typeof A.onBlur&&A.onBlur(r),H(!1)},onChange:r=>{"function"==typeof q&&q(r),K(r.target.value)},onFocus:r=>{"function"==typeof A.onFocus&&A.onFocus(r),H(!0)},ref:M,role:"textbox",size:L,value:J}),F&&e(j,{className:W,size:"small"}),a&&e(z,{className:U,onClick:r=>{r.preventDefault(),K(""),"function"==typeof D&&D()},role:"button",children:e(p,{})}),P&&!c(P)&&e(N,{className:T,onClick:Y,children:s(P)?i(P,{size:O[L]}):P}),c(P)&&s(P)&&i(P,X)]})}));B.displayName="Input";export{B as default};
